import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import Input from '@mui/material/Input';
import { useStore } from 'react-redux';

export default function Status({ onChange, defaultValue = null, multiple }: any) {
  const store = useStore();

  const [options]: any = React.useState(store.getState().parcel?.parcelStatus);
  const [inputValue, setInputValue] = React.useState('');

  React.useEffect(() => {}, [inputValue]);

  if (multiple) {
    return (
      <FormControl sx={{ width: '100%' }}>
        <InputLabel id="demo-multiple-chip-label">Status</InputLabel>
        <Select
          variant="standard"
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          defaultValue={defaultValue}
          onChange={(event: SelectChangeEvent) => {
            const {
              target: { value },
            } = event;
            onChange(value);
          }}
          input={<Input id="select-multiple-chip" />}
          renderValue={(selected) => {
            return (selected as unknown as string[]).map((value) => <Chip key={value} label={value} />);
          }}
        >
          {store.getState().parcel?.parcelStatus?.map((v: any, index: number) => (
            <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
              {v.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Autocomplete
      defaultValue={defaultValue}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      getOptionLabel={(option: any) => option.label}
      options={options}
      onChange={(e, newValue) => {
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          fullWidth
          label="Status"
          InputProps={{
            ...params.InputProps,
            endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
          }}
        />
      )}
    />
  );
}
